import { useState, useEffect } from "react";
import ViewHeightFull from "./../../../common/viewHeightFull";
import { ReactComponent as NonVenemous } from "./../../../../assets/images/icon/non-venemous.svg";
import { ReactComponent as Venemous } from "./../../../../assets/images/icon/venemous.svg";
import { ReactComponent as SemiVenemous } from "./../../../../assets/images/icon/semi-venemous.svg";
import Snake from "./../../../../assets/images/picture/snake_image.png";

function IdentificationStep(props) {
  const [loadingState, setLoadingState] = useState(true);
  useEffect(() => {
    setTimeout(() => {
      setLoadingState(false);
    }, 1500);
  }, []);
  return (
    <div className="identification__step">
      <h2>The result of your image analysis</h2>
      <div className="guide">
        <div className="items">
          <div className="item">
            <span>Non venemous</span>
          </div>
          <div className="item">
            <span>venemous</span>
          </div>
          <div className="item">
            <span>semi venemous</span>
          </div>
        </div>
      </div>
      {loadingState && (
        <>
          <ViewHeightFull>
            <div className="loading">
              <div className="loading__parent">
                <div className="loading__child"></div>
              </div>
            </div>
            <div className="notice">
              <p>Please be patient, we are checking your image</p>
            </div>
          </ViewHeightFull>
        </>
      )}
      {!loadingState && (
        <div className="suggestions">
          <div className="items">
            <div
              className="item border-green"
              onClick={() => props.changeStep(3)}
            >
              <div className="top">
                <div className="left">
                  <div className="type__and__name">
                    <div className="type__icon">
                      <NonVenemous />
                    </div>
                    <div className="type__name">
                      <h4>Green Snakes</h4>
                    </div>
                  </div>
                  <div className="tip">
                    <span>Dice snake</span>
                  </div>
                </div>
                <div className="right">
                  <div className="percentage__similarity">
                    <div className="box">
                      <svg className="purple_circle">
                        <circle cx="15" cy="15" r="15"></circle>
                        <circle
                          style={{
                            strokeDashoffset: "calc(95 - (95 * 35) / 100)",
                          }}
                          cx="15"
                          cy="15"
                          r="15"
                        ></circle>
                      </svg>
                      <div className="number">
                        <span>%</span>
                        35
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="content">
                <div className="snake__images">
                  <div className="items">
                    <div className="item">
                      <img src={Snake} alt="" />
                    </div>
                    <div className="item">
                      <img src={Snake} alt="" />
                    </div>
                    <div className="item">
                      <img src={Snake} alt="" />
                    </div>
                    <div className="item">
                      <img src={Snake} alt="" />
                    </div>
                    <div className="item">
                      <img src={Snake} alt="" />
                    </div>
                    <div className="item">
                      <img src={Snake} alt="" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              className="item border-orange"
              onClick={() => props.changeStep(3)}
            >
              <div className="top">
                <div className="left">
                  <div className="type__and__name">
                    <div className="type__icon">
                      <Venemous />
                    </div>
                    <div className="type__name">
                      <h4>Green Snakes</h4>
                    </div>
                  </div>
                  <div className="tip">
                    <span>Dice snake</span>
                  </div>
                </div>
                <div className="right">
                  <div className="percentage__similarity">
                    {" "}
                    <div className="box">
                      <svg>
                        <circle cx="15" cy="15" r="15"></circle>
                        <circle
                          style={{
                            strokeDashoffset: "calc(95 - (95 * 35) / 100)",
                          }}
                          cx="15"
                          cy="15"
                          r="15"
                        ></circle>
                      </svg>
                      <div className="number">
                        <span>%</span>
                        35
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="content">
                <div className="snake__images">
                  <div className="items">
                    <div className="item">
                      <img src={Snake} alt="" />
                    </div>
                    <div className="item">
                      <img src={Snake} alt="" />
                    </div>
                    <div className="item">
                      <img src={Snake} alt="" />
                    </div>
                    <div className="item">
                      <img src={Snake} alt="" />
                    </div>
                    <div className="item">
                      <img src={Snake} alt="" />
                    </div>
                    <div className="item">
                      <img src={Snake} alt="" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              className="item border-dark-orange"
              onClick={() => props.changeStep(3)}
            >
              <div className="top">
                <div className="left">
                  <div className="type__and__name">
                    <div className="type__icon">
                      <SemiVenemous />
                    </div>
                    <div className="type__name">
                      <h4>Green Snakes</h4>
                    </div>
                  </div>
                  <div className="tip">
                    <span>Dice snake</span>
                  </div>
                </div>
                <div className="right">
                  <div className="percentage__similarity">
                    {" "}
                    <div className="box">
                      <svg>
                        <circle cx="15" cy="15" r="15"></circle>
                        <circle
                          style={{
                            strokeDashoffset: "calc(95 - (95 * 35) / 100)",
                          }}
                          cx="15"
                          cy="15"
                          r="15"
                        ></circle>
                      </svg>
                      <div className="number">
                        <span>%</span>
                        35
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="content">
                <div className="snake__images">
                  <div className="items">
                    <div className="item">
                      <img src={Snake} alt="" />
                    </div>
                    <div className="item">
                      <img src={Snake} alt="" />
                    </div>
                    <div className="item">
                      <img src={Snake} alt="" />
                    </div>
                    <div className="item">
                      <img src={Snake} alt="" />
                    </div>
                    <div className="item">
                      <img src={Snake} alt="" />
                    </div>
                    <div className="item">
                      <img src={Snake} alt="" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default IdentificationStep;
